var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"z-200 fixed top-0 w-screen transition-all",class:{
        'is-sticky shadow bg-white': _vm.sticky,
        '!bg-gray-800 !shadow-none navigation-visible':
            _vm.$root.navigationIsVisble
    }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }